import { render, staticRenderFns } from "./modalForAlertMissingSigners.vue?vue&type=template&id=4a8500d0&"
import script from "./modalForAlertMissingSigners.vue?vue&type=script&lang=js&"
export * from "./modalForAlertMissingSigners.vue?vue&type=script&lang=js&"
import style0 from "./modalForAlertMissingSigners.vue?vue&type=style&index=0&id=4a8500d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports